// extracted by css-extract-rspack-plugin
export default {"scrollable":"izZz1","descriptionLabel":"GnKZv"};